export default [{
    path: '/trade/cashier',
    component: resolve => require(['./cashier.vue'], resolve)
  },{
    path: '/trade/paySucc',
    component: resolve => require(['./paySucc.vue'], resolve)
  }]
  


// WEBPACK FOOTER //
// ./src/views/trade/router.js